import React from 'react'
import { get, has, isEmpty, map, truncate, unescape } from 'lodash'

import Gallery from './Gallery'
import Features from './Features'
import labels from '../../../configuration/labels'
import ArrowRight from '../../../assets/icons/arrow-right-alt.svg'
import { stripHtml } from '../../../utilities/content/html'
import ModalClose from '../../../assets/icons/modal-close.svg'

function getAccommodationImages(accommodation) {
  const leonardoImages = get(accommodation, 'viewExtensions.leonardoImages', [])
  if (!isEmpty(leonardoImages)) {
    return map(leonardoImages)
  }
  if (!isEmpty(get(accommodation, 'images'))) {
    return map(get(accommodation, 'images', []), (item) => ({
      caption: '',
      url: get(item, 'path'),
    }))
  } 
  if (!isEmpty(get(accommodation, 'viewExtensions.kaptioImages'))) {
    return map(get(accommodation, 'viewExtensions.kaptioImages'), (item) => ({
      caption: '',
      url: get(item, 'path'),
    }))
  } 
  if (get(accommodation, 'defaultImage')) {
    return [{
      caption: '',
      url: get(accommodation, 'defaultImage.path')
    }]
  }
  return []
}

const AccommodationDetails = ({ accommodation, onClose }) => {
  if (!accommodation) return null

  const { viewExtensions } = accommodation
  const { northstar } = viewExtensions
  const hotelName = get(northstar, 'HotelName')
  const hotelDescription = get(accommodation, 'description') || get(northstar, 'HotelDescription')

  const images = getAccommodationImages(accommodation)

  const displayItineraryFlag = get(accommodation, 'viewExtensions.itineraryFlag')
  const itineraryFlagText = get(accommodation, 'viewExtensions.itineraryText')

  return (
    <div className="accommodation-details">
      <div className="title-wrapper">
        <h2 className="title">{unescape(hotelName)}</h2>
        <button className="btn btn-text-only btn-close-modal" onClick={onClose} tabIndex="0">
          <img src={ModalClose} alt="Close" />
        </button>
      </div>
      <div className="accommodation-details__main-content">
        {!!hotelDescription && (
          <p
            className="description"
            dangerouslySetInnerHTML={{
              __html: truncate(stripHtml(hotelDescription.replaceAll(/\s/g,' ')), {
                length: 240,
                separator: ' '
              })
            }}
          />
        )}
        {get(viewExtensions, 'linkLandingPage') === true && (
          <a className="btn link btn-more-details" href={get(viewExtensions, 'landingPage')}>
            {labels.detailsBtn}
            <img src={ArrowRight} alt={labels.detailsBtn} />
          </a>
        )}
        {!isEmpty(images) && (
          <Gallery
            isLeonardoPhotos={has(viewExtensions, 'leonardoImages')}
            itineraryFlag={displayItineraryFlag && itineraryFlagText}
            photos={images}
          />
        )}
      </div>
      <Features accommodationData={accommodation} />
    </div>
  )
}

export default AccommodationDetails
